/* eslint-disable no-param-reassign */
import { AnyAction } from 'redux';
import produce from 'immer';
import { UPDATE_GLOBAL_SPINNER, UPDATE_LOCAL_SPINNER } from '../../../constants/spinner.constants';
import SpinnerState from '../../../models/redux/state/spinner.state';

const initialState: SpinnerState = {
  localSpinner: {
    isVisible: false,
  },
  globalSpinner: {
    isVisible: false,
  },
};

const spinnerReducer = produce((draft: SpinnerState, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_GLOBAL_SPINNER:
      draft.globalSpinner.isVisible = action.isLoading;
      break;
    case UPDATE_LOCAL_SPINNER:
      draft.localSpinner.isVisible = action.isLoading;
      break;
    default:
  }
}, initialState);

export default spinnerReducer;
